/**
 * Order and cart-related API endpoints
 */
import { apiGet, apiPost, apiDelete } from "./client.js";

/**
 * Fetches backend cart items
 * @returns {Promise<Response>} Cart items response
 */
export const getBackendCart = () => apiGet("/cart/items", {}, { credentials: "include", includeSessionToken: true });

/**
 * Adds an item to the backend cart
 * @param {Object} itemData - Cart item data
 * @returns {Promise<Response>} Add to cart response
 */
export const addToBackendCart = (itemData) =>
  apiPost("/cart/items", itemData, { credentials: "include", includeSessionToken: true });

/**
 * Removes an item from the backend cart
 * @param {string} component - Component type
 * @param {string} itemId - Item ID to remove
 * @returns {Promise<Response>} Remove from cart response
 */
export const removeFromBackendCart = (component, itemId) =>
  apiDelete(`/cart/items/${component}/${itemId}`, { credentials: "include", includeSessionToken: true });

/**
 * Clears all items from the backend cart
 * @returns {Promise<Response>} Clear cart response
 */
export const clearBackendCart = () => apiDelete("/cart/clear", { credentials: "include", includeSessionToken: true });

/**
 * Calculates shipping cost for cart items
 * @param {Array} items - Cart items array
 * @param {number} subtotal - Cart subtotal
 * @returns {Promise<Response>} Shipping calculation response
 */
export const calculateShipping = (items, subtotal) =>
  apiPost(
    "/shipping/calculate",
    {
      items,
      subtotal,
    },
    { credentials: "include" }
  );

/**
 * Creates a checkout order
 * @param {Object} checkoutData - Checkout data including PayPal order, notes, shipping, and NIF
 * @returns {Promise<Response>} Checkout response
 */
export const createCheckout = (checkoutData) => apiPost("/checkout", checkoutData, { credentials: "include" });
